import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import AddBank from "./addBank";
import classes from "./index.module.css";
import BankReportFilter from "./BankReportFilter";
import BankReportSummary from "./BankReportSummary";

const Banks = () => {
  const [showAddBank, setShowAddBank] = useState(false);
  const [bankId, setBankId] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  // const [filterParams, setFilterParams] = useState(null);
  const [filterStates, setFilterStates] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);

  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();

  const refreshData = useCallback((filterData = {}) => {
    reportRef.current.applyFilters(filterData);
  }, []);

  const addBank = useCallback((isEdit = false) => {
    if (isEdit) {
      setBankId(reportRef.current.getCurrentRowData()?.bankId);
    }
    setShowAddBank(true);
  }, []);

  const closeBankAc = useCallback(() => {
    setShowAddBank(false);
    setBankId(null);
    setCurrentComponent("grid_reports");
    refreshRef.current.click();
  }, [setCurrentComponent]);

  const debounceCloseBankAc = _.debounce(closeBankAc, 200);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        refreshRef.current.click();
        return;
      }
      if (ctrlKey && key === "e") {
        if (currentRowData) return editRef.current.click();
      }
      if (ctrlKey && key === "b") {
        return addBank();
      }
    },
    [addBank, currentRowData]
  );

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addBank(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addBank, currentRowData]);

  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddBank &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow, showAddBank]);
  useEffect(() => {
    refreshData({ isFilterChanged: true, ...filterStates });
  }, [refreshData, filterStates]);
  return (
    <div className={classes["bank-report-container"]}>
      <Reports
        identifier="bank"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        // filterParams={filterParams}
        // filterStates={filterStates}
        filters={
          <BankReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            // refreshData={refreshData}
            // applyFilters={(params, filterStates) => {
            //   // refreshData(params);
            //   // setFilterParams(params);
            //   // setFilterStates(filterStates);
            // }}
            onFilterShow={onFilterShow}
          />
        }
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
      />
      <BankReportSummary
        refreshData={refreshData}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addBank();
        }}
      />
      <Autocomplete
        show={showAddBank}
        height="70%"
        width="90%"
        closeAutoComplete={debounceCloseBankAc}
      >
        <AddBank
          editBankId={bankId}
          onEscape={debounceCloseBankAc}
          onSave={debounceCloseBankAc}
        />
      </Autocomplete>
    </div>
  );
};

export default Banks;
